import React from "react";

const ChevronLeftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.99993 4.4699C9.73993 4.2099 9.31993 4.2099 9.05993 4.4699L5.99993 7.5299C5.73993 7.7899 5.73993 8.2099 5.99993 8.4699L9.05993 11.5299C9.31993 11.7899 9.73993 11.7899 9.99993 11.5299C10.2599 11.2699 10.2599 10.8499 9.99993 10.5899L7.41326 7.99657L9.99993 5.4099C10.2599 5.1499 10.2533 4.72324 9.99993 4.4699Z" fill="#4F4A4A"/>
  </svg>
);

export default ChevronLeftIcon;
